import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { FormControlLabel, IconButton, TextField } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import HelperText from './HelperText';
const PasswordField = ({ control, name, label, required, autocomplete, }) => {
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    return (_jsx(Controller, { name: name, control: control, render: ({ field: { onBlur, onChange, value,
        // name,
        // ref,
         }, fieldState: { isTouched, error, }, }) => (_jsxs(_Fragment, { children: [_jsx(FormControlLabel, { label: label, labelPlacement: "top", control: (_jsx(TextField, { fullWidth: true, name: name, onChange: onChange, onBlur: onBlur, error: isTouched && !!error, 
                        // helperText={error?.message}
                        required: required, value: value, variant: "outlined", type: showPassword ? undefined : 'password', InputLabelProps: {
                            sx: { color: (t) => (t.portal.global.font.color) },
                        }, InputProps: {
                            sx: {
                                '& fieldset': {
                                    borderColor: (t) => (t.portal.global.font.color),
                                },
                            },
                            endAdornment: (_jsx(IconButton, { "aria-label": "toggle password visibility", onClick: handleClickShowPassword, onMouseDown: handleMouseDownPassword, sx: { color: (t) => (t.portal.global.font.color) }, children: showPassword ? _jsx(Visibility, {}) : _jsx(VisibilityOff, {}) })),
                        }, autoComplete: autocomplete })) }), _jsx(HelperText, { name: name, error: isTouched && error?.message })] })) }));
};
/*
  id="standard-adornment-password"
            type={values.showPassword ? 'text' : 'password'}
            value={values.password}
            onChange={handleChange('password')}
            endAdornment={
            */
PasswordField.defaultProps = {
    required: false,
    autocomplete: 'off',
};
export default PasswordField;
//# sourceMappingURL=PasswordField.js.map